const outletChannelPercentage = (num1, num2) => {
  const data = (Number(num1) / Number(num2)) * 100;
  return data;
};

export { outletChannelPercentage };
